import { NotificationSubscriptionApi } from '../../../API';
import { apiConfig } from '../../../utils/apiConfig';

export function useNotificationSubscription(): NotificationSubscriptionApi {
  return new NotificationSubscriptionApi(apiConfig);
}
